import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function Programs() {
  const [programs, setPrograms] = useState([]);
  useEffect(() => {
    api.get("/programs").then((r) => setPrograms(r.data)).catch(() => {});
  }, []);

  return (
    <section data-testid="programs-section" id="programs" className="bg-[var(--bone-2)] py-24 md:py-32">
      <div className="container-x">
        <div className="grid grid-cols-12 gap-6 items-end mb-16">
          <div className="col-span-12 md:col-span-8">
            <div className="overline text-[var(--terracotta)]">Programs</div>
            <h2 className="font-serif text-4xl md:text-5xl mt-4 tracking-[-0.02em] leading-[1.05]">
              Two programs.<br/>One promise — show up every year.
            </h2>
          </div>
          <div className="col-span-12 md:col-span-4 text-sm text-[var(--ink)]/70">
            Each program is run with a local partner organisation and audited annually.
            We publish every cost line, down to nails.
          </div>
        </div>

        <div className="grid grid-cols-12 gap-6">
          {programs.map((p, i) => (
            <article
              key={p.id}
              data-testid={`program-${p.id}`}
              className={`relative col-span-12 md:col-span-6 bg-[var(--bone)] p-8 md:p-12 ${i === 0 ? "" : "md:translate-y-12"}`}
              style={{
                backgroundImage:
                  i === 0
                    ? "linear-gradient(0deg, rgba(244,241,232,1) 0%, rgba(244,241,232,1) 100%)"
                    : "linear-gradient(0deg, rgba(244,241,232,1) 0%, rgba(244,241,232,1) 100%)",
              }}
            >
              <div className="flex items-baseline justify-between">
                <div className="overline text-[var(--terracotta)]">0{i + 1}</div>
                <div className="font-mono text-xs text-[var(--muted)]">{p.id}</div>
              </div>
              <h3 className="font-serif text-4xl md:text-5xl mt-6 leading-none tracking-[-0.02em]">{p.title}</h3>
              <p className="font-serif italic text-2xl text-[var(--terracotta)] mt-2">{p.subtitle}</p>
              <p className="text-[var(--ink)]/75 mt-6 leading-relaxed">{p.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
